import { action } from 'mobx';
import { FormBase } from 'core/components';
import { BaseViewStore } from 'core/stores';
import { formInvalidate } from 'core/utils';
import _ from 'lodash';
import moment from 'moment';
import { sourceOfChange } from 'common/constants';

class LookupEditViewStore extends BaseViewStore {
	// Used for notifications (create, edit)
	itemName = '';

	form = new FormBase({
		onSuccess: async () => {
			const mode = this.getEditMode();
			if (mode === 'edit') {
				await this.updateLookup();
			} else if (mode === 'create') {
				await this.createLookup();
			}
		},
	});

	format = null;

	constructor(rootStore) {
		super(rootStore);
		this.parentView = rootStore.lookupViewStore;
		this.listStore = rootStore.lookupViewStore.listStore;
		let locale = window.navigator.userLanguage || window.navigator.language;
		moment.locale(locale);
		let localeData = moment.localeData();
		this.format = localeData.longDateFormat('L');
		this.initialize();
	}

	getEditMode() {
		const queryParams = this.rootStore.routerStore.routerState.queryParams;
		return queryParams['editId'] !== undefined ? 'edit' : queryParams['create'] !== undefined ? 'create' : 'none';
	}

	@action async initialize() {
		this.itemName = this.parentView.editView.itemName;
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
		this.form.reset();
		this.form.init(this.parentView.editView.initFields);

		if (this.getEditMode() === 'edit') {
			await this.getLookup();
		} else {
			this.form.clear();
		}
	}

	@action async getLookup() {
		let parameters = this.parentView.selectedLookup.parameters;
		let options = parameters.embed ? { embed: parameters.embed } : null;
		let updateKey;
		let updateVal;
		await this.listStore.getLookup(parameters.lookup, options);
		this.form.update(this.listStore.item);
		if (parameters.dropDownValueModel) {
			_.each(parameters.dropDownValueModel, (val, key) => {
				updateKey = val[0];
				updateVal = {
					value: this.listStore.item[key][val[1]],
					label: this.listStore.item[key][val[2]],
				};
				this.form.$(updateKey).set('value', updateVal);
			});
		}
	}

	@action async updateLookup() {
		this.suspend();
		try {
			let updateValues = this.form.values();
			if (this.parentView.selectedLookup.parameters.dropDownValueModel) {
				let updateKey;
				let updateVal;
				_.each(this.parentView.selectedLookup.parameters.dropDownValueModel, val => {
					updateKey = val[0];
					updateVal = updateValues[updateKey]['value'];
					updateValues[updateKey] = updateVal;
				});
			}
			await this.listStore.updateLookup(
				{
					id: this.rootStore.routerStore.routerState.queryParams.editId,
					...updateValues,
				},
				this.parentView.selectedLookup.parameters.lookup,
				sourceOfChange.editLookup + ' - ' + this.parentView.selectedLookup.parameters.lookup
			);
			this.rootStore.notificationStore.success([
				'LOOKUPUPDATE.LOOKUP',
				{
					name: updateValues.name ? updateValues.name : updateValues[Object.keys(updateValues)[0]],
					lookup: this.itemName,
				},
			]);
			await this.parentView.findLookup();
			this.parentView.closeEditModal();
		} catch (err) {
			formInvalidate({ form: this.form, err });
		}
		this.resume();
	}

	@action.bound
	createLookup = async () => {
		this.suspend();
		try {
			let updateValues = this.form.values();
			if (this.parentView.selectedLookup.parameters.dropDownValueModel) {
				let updateKey;
				let updateVal;
				_.each(this.parentView.selectedLookup.parameters.dropDownValueModel, val => {
					updateKey = val[0];
					updateVal = updateValues[updateKey]['value'];
					updateValues[updateKey] = updateVal;
				});
			}
			await this.listStore.createLookup(
				{
					...updateValues,
				},
				this.parentView.selectedLookup.parameters.lookup,
				sourceOfChange.createLookup + ' - ' + this.parentView.selectedLookup.parameters.lookup
			);
			this.rootStore.notificationStore.success([
				'LOOKUPCREATE.LOOKUP',
				{
					name: updateValues.name ? updateValues.name : updateValues[Object.keys(updateValues)[0]],
					lookup: this.itemName,
				},
			]);
			await this.parentView.findLookup();
			this.parentView.closeEditModal();
		} catch (err) {
			formInvalidate({ form: this.form, err });
		}
		this.resume();
	};
}

export default LookupEditViewStore;



// WEBPACK FOOTER //
// ./src/modules/lookup/stores/LookupEditViewStore.js